<template>
  <div
    ref="rootEl"
    class="grid-page-tile-chart-wrapper"
  >
    <grid-page-tile-chart-content
      v-if="shouldRender"
      :grid-page-tile="props.gridPageTile"
    />
    <m-spinner
      v-else
      class="_spinner"
    />
  </div>
</template>

<script setup>
import GridPageTileChartContent from '@/components/custom-grid/GridPageTileChartContent.vue';
import usePrintMode from '@/composables/export/print-mode';
import useVisibility from '@/composables/visibility';
import { computed, ref } from 'vue';

const props = defineProps({ gridPageTile: { type: Object, required: true } });

const rootEl = ref(null);
// Unmount chart tiles that have been off-screen for 15s so a long scroll through
// a large dashboard doesn't retain N Highcharts instances + their processed
// data on the heap. 15s is long enough to survive scroll-up/scroll-back without
// thrashing.
const { isVisible } = useVisibility(rootEl, {
  rootMargin: '400px',
  unmountDelayMs: 15_000,
});
const { isPrint } = usePrintMode();

const shouldRender = computed(() => isPrint.value || isVisible.value);
</script>

<style scoped lang="scss">
.grid-page-tile-chart-wrapper {
  width: 100%;
  height: calc(100% - 6rem);
  display: flex;
  flex-direction: column;
}

._spinner {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
